<template>
  <div id="aula-modals">
    <b-modal :visible="browserCheck" centered ok-only>
      <div slot="modal-header" class="w-100">
        <a class="modal-header-text"> {{ $getText('BROWSER_CHECK_HEADER') }}</a>
      </div>
      <div class="modal-content-text">
        {{ $getText('BROWSER_CHECK_TEXT_1') }}
        <br />
        {{ $getText('BROWSER_CHECK_TEXT_2') }}
        <ul>
          <li>
            <a class="browser-link" href="https://www.google.dk/chrome/browser/desktop/index.html">
              {{ $getText('BROWSER_CHROME_DOWNLOAD') }}
              <i class="icon-Aula_forward-arrow"
            /></a>
          </li>
          <li>
            <a class="browser-link" href="https://www.microsoft.com/da-dk/windows/microsoft-edge">
              {{ $getText('BROWSER_EDGE_DOWNLOAD') }}
              <i class="icon-Aula_forward-arrow"
            /></a>
          </li>
          <li>
            <a class="browser-link" href="https://support.apple.com/downloads/safari">
              {{ $getText('BROWSER_SAFARI_DOWNLOAD') }}
              <i class="icon-Aula_forward-arrow"
            /></a>
          </li>
          <li>
            <a class="browser-link" href="https://www.mozilla.org/da/firefox/new/">
              {{ $getText('BROWSER_FIREFOX_DOWNLOAD') }}
              <i class="icon-Aula_forward-arrow"
            /></a>
          </li>
        </ul>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { types } from '../../store/types/types';
import { mapGetters } from 'vuex';
import { useUserProfileStore } from '../../../shared/stores';
export default {
  data: function () {
    return {};
  },
  computed: {
    ...mapGetters({
      browserCheck: types.GET_BROWSER_CHECK,
    }),
    userProfileStore() {
      return useUserProfileStore();
    },
    profile() {
      return this.userProfileStore.institutionProfile;
    },
  },
};
</script>

<style scoped lang="scss">
@use '../../../shared/assets/scss/core/variables' as *;
@use '../../../shared/assets/scss/core/breakpoints' as *;

.browser-link {
  color: #2091a2;
  font-weight: bold;
  &:hover {
    text-decoration: underline;
  }

  .icon-Aula_forward-arrow {
    font-size: 10px;
  }
}
</style>
